import {GlobalVariables} from "../GlobalVariables";
import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class BlockHistory {
	static init() {

		let blocks = document.querySelectorAll('.block-history');
		blocks.forEach( (block) => {

			let imageContainer = block.querySelector('.images');
			let images = block.querySelectorAll('.image');
			let timeline = block.querySelector('.timeline');
			let content = timeline.querySelector('.timeline-content');
			let steps = timeline.querySelectorAll('.step');

			let ratio = content.offsetHeight * 2.5;

			let mm = gsap.matchMedia();

			mm.add("(min-width: 992px)", () => {

				ScrollTrigger.create({
					trigger: block,
					start: 'top top',
					end: '+=' + ratio,
					pin: timeline
				});

				ScrollTrigger.create({
					trigger: block,
					start: 'top top',
					end: '+=' + ratio,
					pin: imageContainer
				});

				let scroll = content.offsetHeight - (timeline.offsetHeight - content.offsetTop) + steps[steps.length - 1].offsetHeight;

				gsap.to(content, {
					y: '-' + scroll,
					scrollTrigger: {
						trigger: block,
						start: "top top-=50",
						end: '+=' + ratio,
						scrub: 1,
						onUpdate : (self) => {

							let percent = self.progress * 100;
							let scrolling = (content.offsetHeight * percent) / 100;

							steps.forEach( (step, i) => {

								if( scrolling > step.offsetTop - step.offsetHeight / 1.5 ){
									gsap.to( images[i], {
										opacity : 1
									});
								} else if ( scrolling < step.offsetTop + step.offsetHeight ) {
									gsap.to( images[i], {
										opacity : 0
									});
								}

							});
						}
					}
				});

			});

		});

	}

}
